import { defineStore } from 'pinia'

import type { ToolsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useToolsStore = defineStore('tools', {
  state: (): ToolsStore => ({
    _analyticsFirstSuccessInit: false,
    clarityReady: false,
    metaPixelReady: false,
  }),
  actions,
  getters,
})
